<template>
  <header class="topbar">
    <div class="topbar-mobile">
      <div class="logo">
        <img src="../assets/image/logo.png" alt="logo" />
      </div>
      <div class="hamburger" :class="{ isActive: mobileMenuActive }">
        <div class="hamburger-box" @click="toggleMobileMenu()">
          <div class="hamburger-inner"></div>
        </div>
      </div>
    </div>
    <div class="company">
      Firma: <router-link to="/company">{{getMainCompanyName}}</router-link>
    </div>
    <div class="topbar-info">
      <!-- <div class="language">
        Język:
        <b-dropdown
          toggle-tag="div"
          toggle-class="nav-link dropdow-toggle"
          class="nav-item"
        >
          <template v-slot:button-content>
            <span class="flag flag-pl"></span> Polski
          </template>
          <b-dropdown-item>
            <span class="flag flag-pl"></span> Polski
          </b-dropdown-item>
          <b-dropdown-item>
            <span class="flag flag-de"></span> Niemiecki
          </b-dropdown-item>
          <b-dropdown-item>
            <span class="flag flag-fr"></span> Francuski
          </b-dropdown-item>
        </b-dropdown>
      </div> -->
      <div class="user">
        Witaj,
        <router-link to="/account">{{this.getFullName}}</router-link>
      </div>
      <div class="logout">
        <button class="logout-btn" v-on:click="logout"><i class="fas fa-sign-out-alt"></i> Wyloguj się</button>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters, mapMutations, mapActions} from "vuex";

export default {
  name: "TheTopbar",
  data() {
    return {};
  },
  computed: {
    ...mapGetters("user", ["getFullName"]),
    ...mapGetters("app", ["mobileMenuActive"]),
    ...mapGetters("company", ["getMainCompanyName"]),
  },
  methods: {
    ...mapMutations("app", ["toggleMobileMenu"]),
    ...mapActions("user", ["logout"])
  },
};
</script>